import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardModule } from '../dashboard/dashboard.module';
import { SliderModule } from '../slider/slider.module';
import { BenefitBoxModule } from '../benefit-box/benefit-box.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SliderModule,
    BenefitBoxModule
  ],

})
export class BenefitsItemModule { }
